import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b261b8a2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b261b8a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b261b8a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b261b8a2')) {
      api.createRecord('b261b8a2', component.options)
    } else {
      api.reload('b261b8a2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b261b8a2&scoped=true", function () {
      api.rerender('b261b8a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchant/system/index.vue"
export default component.exports